import React, { useState } from "react";
import ModalBox from "../../../../components/modal/ModalBox";
import { Input, TextArea } from "../../../../components/Form";
import { optimizeFunction } from "../../../../utils/regex";
import useButtonLoader from "../../../../hooks/UseButtonLoader";
import { toastMessage } from "../../../../utils/toastMessage";
import { addContentApi } from "../../../../services/cms";

const AddNotice = ({
  setAddModal,
  addModal,
  getCmsDetails,
  userType,
  type,
}) => {
  const [buttonref, buttonLoader] = useButtonLoader("Save");
  const [title, setTitle] = useState("");
  const [subTitle, setSubTitle] = useState("");
  const [error, setError] = useState("");

  const modalClose = () => {
    setError("");
    setTitle("");
    setSubTitle("");
    setAddModal(false);
  };

  const validation = () => {
    let status = true;
    if (!title) {
      setError("Title is mandatory");
      status = false;
    }
    return status;
  };

  const addNoticeHandler = async () => {
    if (validation()) {
      try {
        buttonLoader(true);
        const formData = new FormData();
        formData.append("title", title);
        formData.append("subTitle", subTitle || "");
        formData.append("contentType", type);
        formData.append("userType", userType);
        const { data } = await addContentApi(formData);
        if (data.code === 200) {
          toastMessage(data.message, "success", "addNotice");
          getCmsDetails();
          modalClose();
        } else {
          toastMessage(data.message, "error", "addNotice");
        }
      } catch (error) {
        console.log("error", error);
      } finally {
        buttonLoader(false);
      }
    }
  };
  return (
    <ModalBox
      status={addModal}
      onClose={modalClose}
      title={"Add Notice"}
      closeIcon
      size={"sm"}
      custom
      customizedFooter={
        <button className="btn_size" ref={buttonref} onClick={addNoticeHandler}>
          Save
        </button>
      }
    >
      <div>
        <div className="form-group mb-2">
          <Input
            type="text"
            name="subTitle"
            value={subTitle || ""}
            onChange={(e) => {
              setSubTitle(e.target.value);
            }}
            placeholder="Enter Sub Title..."
            className={`form-control`}
            label={"Sub Title"}
          />
        </div>
        <div className="form-group mb-2">
          <TextArea
            name="title"
            value={title || ""}
            required
            onChange={(e) => {
              setTitle(e.target.value);
            }}
            placeholder="Enter Title / Notice..."
            className={`form-control`}
            label={"Title"}
            error={!title && error}
          />
        </div>
      </div>
    </ModalBox>
  );
};

export default AddNotice;
